import React from "react";
import { Link } from "react-router-dom";
import { Construction } from "lucide-react";
import { Panel } from "@/components/ui";
import { useBusiness } from "@/context/BusinessContext";
import { api } from "@/lib/api";

export default function Placeholder({ title, phase, description }) {
  const { active } = useBusiness();
  const [members, setMembers] = React.useState([]);
  React.useEffect(() => {
    if (title === "Business" && active) api.get(`/businesses/${active.id}/members`).then((r) => setMembers(r.data)).catch(() => {});
  }, [active, title]);

  return (
    <div>
      <div className="heading-eyebrow mb-1">{phase}</div>
      <h1 className="text-xl font-semibold mb-6">{title}</h1>
      <Panel className="p-8" data-testid={`placeholder-${title.toLowerCase().replace(/ /g, "-")}`}>
        <Construction size={22} style={{ color: "var(--accent)" }} />
        <p className="mt-4 text-sm" style={{ color: "var(--text-2)", maxWidth: 560 }}>
          {description || "This module arrives in an upcoming phase of the build. The foundation, data model, and API contracts for it are already defined in the specification."}
        </p>
        {title === "Business" && active && (
          <div className="mt-6">
            <div className="heading-eyebrow mb-2">Workspace</div>
            <p className="text-sm" style={{ color: "var(--text)" }}>{active.name}</p>
            <div className="heading-eyebrow mt-4 mb-2">Members</div>
            {members.map((m) => (
              <div key={m.membershipId} className="text-sm mono py-1" style={{ color: "var(--text-2)" }}>
                {m.email} — {m.role}
              </div>
            ))}
            <Link to="/onboarding/business" className="btn btn-sm mt-4">Edit business profile</Link>
          </div>
        )}
      </Panel>
    </div>
  );
}
